import { TextRegular } from "@hm/fundamental"
import React from "react"
import { useTranslation } from "react-i18next"

export interface TraceIdBadgeProps {
	traceId: string | undefined
	"data-cy"?: string
}

export const TraceIdBadge: React.FC<TraceIdBadgeProps> = ({
	traceId,
	"data-cy": dataCy = "trace-id-badge",
}) => {
	const { t } = useTranslation("shared", { keyPrefix: "traceIdBadge" })

	if (!traceId) {
		return null
	}

	return (
		<TextRegular data-cy={dataCy} className="text-negative font-bold">
			{t("traceIdLabel")}: {traceId}
		</TextRegular>
	)
}
